import { render } from "./MyViolations.vue?vue&type=template&id=2baefde2"
import script from "./MyViolations.vue?vue&type=script&lang=js"
export * from "./MyViolations.vue?vue&type=script&lang=js"

import "./MyViolations.vue?vue&type=style&index=0&id=2baefde2&lang=less"
script.render = render

export default script